import { useEffect, useRef, useState } from 'react'
import { useNavigate, useSearchParams, Link } from 'react-router-dom'
import { attendeeApi, attendeeAuth } from '@/api/attendee'

export default function AttendeeMagicLinkPage() {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const [error, setError] = useState<string | null>(null)
  const ran = useRef(false)

  useEffect(() => {
    if (ran.current) return
    ran.current = true

    const token = params.get('token')
    if (!token) { setError('This sign-in link is missing its token.'); return }

    attendeeApi.exchange(token)
      .then(r => {
        attendeeAuth.setSession(r.data.accessToken, r.data.attendeeName)
        navigate('/attendee/overview', { replace: true })
      })
      .catch(e => {
        setError(e?.response?.data?.detail ?? 'This sign-in link is invalid or has expired.')
      })
  }, [params, navigate])

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-2xl shadow-sm p-8 text-center">
        {error ? (
          <>
            <h1 className="text-lg font-semibold text-slate-900 mb-2">Sign-in failed</h1>
            <p className="text-sm text-slate-500 mb-4">{error}</p>
            {attendeeAuth.slug() && (
              <Link to={`/attendee/${attendeeAuth.slug()}/login`} className="text-sm text-indigo-600 hover:underline">
                Request a new link
              </Link>
            )}
          </>
        ) : (
          <>
            <div className="w-6 h-6 mx-auto border-2 border-indigo-500 border-t-transparent rounded-full animate-spin mb-3" />
            <p className="text-sm text-slate-500">Signing you in…</p>
          </>
        )}
      </div>
    </div>
  )
}
